import all from '@mailobj-browser/front/js/selectors/all.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as menu from './menu.js'

export const {
  close,
  focus,
  open,
  opener
} = menu

const keys = object(null, {
  ArrowDown: async (list, current) => {
    return current.nextElementSibling
  },
  ArrowUp: async (list, current) => {
    return current.previousElementSibling
  }
})

const onKeyDown = object(menu.onKeyDown, {
  keys
})

export default async (
  list
) => {
  const element = opener(list)

  await menu.display(list, element)

  if (element.matches('select')) {
    const { options: [selected], value = '' } = element
    const inputs = all('input', list)
    const [first] = inputs
    let isValue = false

    for (const input of inputs) {
      if (input.value === value) {
        isValue = true
        input.scrollIntoView()
        input.click()
        input.focus()
        break
      }
    }

    if (isValue === false) {
      first.scrollIntoView()
      first.focus()
    }
  } else {
    focus(list)
  }

  onKeyDown.listen(list)
}
